import { Component, OnInit, effect, Injector } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { Meta } from '@angular/platform-browser';
import { CanonicalService } from 'src/app/services/canonical.service';
import { MainService } from 'src/app/services/main.service';
import { SharedService } from 'src/app/services/shared.service';
import { ApiService } from 'src/app/services/api.service';
import { localStorageService } from 'src/app/services/localstorage.service';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { CaptchaService } from 'src/app/services/captcha.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ReferralCodeComponent } from 'src/app/pages/public/referral-code/referral-code.component';
import { Email, Name_1 } from 'src/app/shared/regex';
import { PasswordStrengthService } from 'src/app/services/password-strength.service';
import { LegalConsentComponent } from 'src/app/pages/public/legal-consent/legal-consent.component';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent implements OnInit {
  public env = environment;
  signUpForm: UntypedFormGroup;
  queryParamSubscription: Subscription = new Subscription;
  ip_country_id: string | undefined;
  reachOption: any = [];
  in_app_link = false;
  hidePwd = false;
  currencyList = [];
  countryList = [];
  country_list: any[] = [];
  selectedCountry: any;
  validator: number[] = [];
  minLength : boolean = false;
  hasUpperCase: boolean = false;
  hasMaxChar: boolean = false;
  hasNumber : boolean = false;
  hasSpecialChar : boolean = false;
  totalStrength: number = 0;
  showPassTooltip  = false;
  mask = '0000-000-000';
  mobile_arr = [];
  sub_industrys = [];
  industryList = [];
  ispasswordStrong: boolean =true;
  counCurData = {
    country_id: 1,
    currency_id: 1
  }
  step = {
    REGISTER: 'REGISTER',
    VERIFY_OTP: 'VERIFY_OTP'
  };
  selectedStep = '';

  otpForm: UntypedFormGroup;
  otpValueGroup = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'];
  otp_id = '';
  referral_code = ''
  referralCodeExist = false;
  bsModalRef: BsModalRef | undefined;
  countdown: number = 180;
  countdownInterval: any;
  last4Number: string = '';
  countries = [];
  errorotp: any;
  checkBtn: boolean = false;
  randomString = Math.random().toString(36).substring(2, 10);
  // both legal documents are reviewed and accepted from the legal modal before sign up proceeds
  legalAccepted = false;

  public environment = environment;
  passwordStrength: any;
  constructor(private fb: UntypedFormBuilder, private router: Router, private route: ActivatedRoute, public mainService: MainService,
    private metaTagService: Meta, private _captcha: CaptchaService,
    private canonicalService: CanonicalService, private _local: localStorageService,
    private apiSer: ApiService, public _shared: SharedService, private _loader: LoaderService, private modalService: BsModalService, private cs: CaptchaService, private passwordStrengthService: PasswordStrengthService, private injector: Injector
  ) {
    this.signUpForm = this.fb.group({
      // doctor_name: ['', [Validators.required, Validators.pattern(Name_1), Validators.maxLength(30)]],
      doctor_email: ['', [Validators.required, Validators.pattern(Email), Validators.pattern(/^[a-zA-Z0-9@._%+-]+$/)]],
      doctor_password: ['', [Validators.required, Validators.minLength(8), this._shared.noWhitespaceValidator()]],
      country_code: ['', [Validators.required]],
      TnC: [false, [Validators.required]],
    });
    this.selectedStep = this.step.REGISTER;
    this.otpForm = this.fb.group({
      first: ['', [Validators.required, Validators.maxLength(1)]],
      second: ['', [Validators.required, Validators.maxLength(1)]],
      third: ['', [Validators.required, Validators.maxLength(1)]],
      fourth: ['', [Validators.required, Validators.maxLength(1)]],
      fifth: ['', [Validators.required, Validators.maxLength(1)]],
      sixth: ['', [Validators.required, Validators.maxLength(1)]],
    });
  }

  ngOnInit(): void {
    // Editing the email invalidates any acceptance already given - the capture
    // records the address that was agreed under, so it has to be retaken.
    this.signUpForm.controls['doctor_email'].valueChanges.subscribe(() => {
      this.resetLegalAcceptance();
    });

    if (environment.production) {
      this.canonicalService.setCanonicalURL('https://business.recuvery.com/register/');
      if (this.metaTagService.getTag('name= "title"')) {
        this.metaTagService.removeTag('name= "title"');
        this.metaTagService.removeTag('name= "description"');
        this.metaTagService.removeTag('name= "robots"');
        this.metaTagService.updateTag({ name: 'title', content: 'Register your Business with recuvery' });
        // tslint:disable-next-line:max-line-length
        this.metaTagService.updateTag({ name: 'description', content: 'Sign up with recuvery to easily manage and grow your business and take advantage of the most popular payment plan features.' });
        this.metaTagService.updateTag({ name: 'robots', content: 'index, follow' });
      } else {
        this.metaTagService.addTags([
          { name: 'title', content: 'Register your Business with recuvery' },
          // tslint:disable-next-line:max-line-length
          { name: 'description', content: 'Sign up with recuvery to easily manage and grow your business and take advantage of the most popular payment plan features.' },
          { name: 'robots', content: 'index, follow' }
        ]);
      }
    }

    const token = this._local.customGetItem('token');

    // if access token is there then redirect to dashboard 
    if (token !== null && token !== undefined) {
      this.router.navigate(['app/dashboard']);
    }
    // this.getIndustryList();
    if (this.mainService.path_redirect_to) {
      this.router.navigate([], { queryParams: { route_link: this.mainService.path_redirect_to } });
    }
    effect(() => {
      const data = this.mainService.ip_country_id();
      if (data && data) {
        this.ip_country_id = data;
      }
    }, { injector: this.injector, allowSignalWrites: true });
    effect(() => {
      const data = this._shared.country_data();
      if (data && data.length) {
        this.country_list = data;
        this.counCurData.country_id = data[0]['country_id'];
        this.counCurData.currency_id = data[0]['currency'][0]['currency_id'];
        if (!this.signUpForm.get('country_code')?.value) {
          this.setDefaultCountry();
        }
      } else {
        this.country_list = [];
      }
    }, { injector: this.injector, allowSignalWrites: true });

    // get details useragent to check the device
    let details = window.navigator.userAgent;

    /* Creating a regular expression
    containing some mobile devices keywords
    to search it in details string*/
    let regexp = /android|iphone|kindle|ipad/i;

    /* Using test() method to search regexp in details
    it returns boolean value*/
    let isMobileDevice = regexp.test(details);

    if (isMobileDevice) {
      // console.log("You are using a Mobile Device");
      this.in_app_link = true;
    } else {
      // console.log("You are using Desktop");
    }

    this.route.queryParams.subscribe(params => {
      this.referral_code = params['referral_code'] || '';
      this.referralCodeExist = true;
    });
    this.route.queryParams.subscribe(params => {
      this.referral_code = params['referral_code'] || '';
      this.referralCodeExist = true;
    });
    this.signUpForm.get('doctor_password')?.valueChanges.subscribe(password => {
    if ((/[A-Z]/.test(password)) && (/[a-z]/.test(password))) {
      this.hasUpperCase = true;
    }else{
      this.hasUpperCase = false;
    }
    if (/[0-9]/.test(password)) {
      this.hasNumber = true;
    }else{
      this.hasNumber = false;
    }
    if (/[^A-Za-z0-9]/.test(password)) {
      this.hasSpecialChar = true;
    }else{
        this.hasSpecialChar = false;
      }

    if (password.length >= 8 ) {
      this.hasMaxChar = true;
    }else{
      this.hasMaxChar = false;
    }
    this.totalStrength = (Number(this.hasUpperCase) + Number(this.hasNumber) + Number(this.hasSpecialChar) + Number(this.hasMaxChar))
    if(this.totalStrength >= 4){
      this.ispasswordStrong = true;
    }else{
      this.ispasswordStrong = false;
    }
      this.passwordStrength = this.passwordStrengthService.calculatePasswordStrength(password);
    });
  }
  removeReadonly(event: any) {
    event.target.removeAttribute('readonly');
  }

  onCountryChange(event: Event) {
    const country_id = (event.target as HTMLSelectElement).value;
    const country = this.country_list.find(
      (c: any) => String(c.country_id) === String(country_id)
    );
    if (country) {
      this.applyCountrySelection(country);
    }
  }

  applyCountrySelection(country: any) {
    this.selectedCountry = country;
    this.signUpForm.patchValue({ country_code: country.country_id });
    this.counCurData.country_id = country.country_id;
    this.counCurData.currency_id = country['currency']?.[0]?.['currency_id'];
  }

  setDefaultCountry() {
    const country =
      this.country_list.find((c: any) => String(c.country_code).toUpperCase() === 'US') ||
      this.country_list.find((c: any) => c.mobile_code === '+1') ||
      (this.country_list.length ? this.country_list[0] : null);
    if (country) {
      this.applyCountrySelection(country);
    }
  }

  onInput(event: any, currentIndex: number, method:any=''): void {
   
    const inputValue = method=='paste'?event:event.target.value;
    const normalizedValue = (inputValue ?? '').toString();
    if (!/^\d$/.test(normalizedValue)) {
      this.otpForm.get(this.otpValueGroup[currentIndex])?.setValue('');
      return;      
    }
   
    if (inputValue && (currentIndex < (this.otpValueGroup.length - 1))) {
      const nextInput = this.otpValueGroup[currentIndex + 1];
      this.setFocus(nextInput);
    }
    if (currentIndex === this.otpValueGroup.length - 1 && inputValue) {
      setTimeout(() => {
        this.verifyOtp();
      }, 100);
    }
  }

  onPasteHandler(data:any){
    const sanitizedData = (data || '').replace(/\s/g, '');
    if(/^\d{1,6}$/.test(sanitizedData)){
      let splitData=sanitizedData.split('')
        for(let i=0;i<splitData.length;i++){
          this.otpForm.controls[this.otpValueGroup[i]].patchValue(splitData[i]);
        }
        this.onInput(splitData[splitData.length-1],splitData.length-2,'paste') 
    }
    
  }

  onDelete(event: any, currentIndex: number): void {
    if (!event.target.value && currentIndex > 0) {
      const previousInput = this.otpValueGroup[currentIndex - 1];
      this.setFocus(previousInput);
    }
  }

  setFocus(input: string) {
    if (input) {
      document.getElementById(input)?.focus();
    }
  }
  // validate email first whether email exist or not
  async submitForm() {
    // console.log('working or no');

    // the legal documents must be accepted before the sign up is sent
    if (this.selectedStep == this.step.REGISTER && !this.legalAccepted) {
      this.showLegalModal(true);
      return;
    }

    this.startCountdown();
    if (this.signUpForm.invalid) {
      this.signUpForm.markAsDirty();
      this.signUpForm.markAllAsTouched();
      return;
    }
    if (this.selectedStep == this.step.REGISTER) {
      if (!(this.signUpForm.controls['doctor_email'].value + '').trim()) {
        this._shared.customPopups('Please enter valid email', 1);
        return;
      }
      if (!this.ispasswordStrong) {
        return;
      }
      this._loader.showLoader();
      const captcha = await this._captcha.getCaptchaToken();
      // console.log('Captcha token:', token);
      const data: {
        doctor_email: string,
        captcha: string,
        referral_code?: string
      } = {
        doctor_email: this.signUpForm.controls['doctor_email'].value + '',
        captcha
      };
      if (this.referral_code) {
        data['referral_code'] = this.referral_code;
      }

      this.apiSer.api(data, 'auth/send_otp_email').subscribe(response => {
        // console.log('api working');

        if (response && !response.is_error) {
          this.selectedStep = this.step.VERIFY_OTP;
          this.otp_id = response.otp_id;

          // this._shared.customPopups('Otp sent to your mail', 0);
        }
        else {
          this.errorotp = response.original_text;
          console.log(this.errorotp, "otp value");
          this.signUpForm.setErrors({ credentialsMismatch: true });
          this.otpForm.markAsDirty();
          this.otpForm.markAsTouched();
          window.scroll(0, 0);
        }
      })
      return;
    }

    const selectedCountryId = this.selectedCountry?.country_id || this.counCurData.country_id;
    const selectedCurrencyId = this.selectedCountry?.['currency']?.[0]?.['currency_id'] || this.counCurData.currency_id;
    // persist the chosen country so the business-info step can resolve it
    this._local.customSetItem('register_country_id', selectedCountryId);
    const data = {
      doctor_name: '',
      doctor_email: this.signUpForm.controls['doctor_email'].value,
      doctor_password: this._shared.crypto(this.signUpForm.controls['doctor_password'].value),
      country_id: selectedCountryId,
      currency_id: selectedCurrencyId,
      doctor_image: undefined,
      // capture of the screen at acceptance; the API uploads it to S3
      legal_consent: LegalConsentComponent.storedAcceptanceCapture()
    };
    // console.log(data);
    this.mainService.registerUser(data);
  }

  verifyOtp() {
    if (this.otpForm.invalid) {
      this.otpForm.markAsDirty();
      this.otpForm.markAllAsTouched();
      return;
    }
    let data;
    let value = '';
    this.otpValueGroup.filter(input => value += this.otpForm.value[input]);
    data = {
      otp: value,
      otp_id: this.otp_id
    };
    this.apiSer.api(data, 'auth/verify_otp_email').subscribe((data) => {
      if (data.is_error == 0) {
        this.submitForm();
      } else {
        this.errorotp = data.original_text;
        this.otpForm.reset();
        setTimeout(() => {
          this.setFocus(this.otpValueGroup[0]);
        }, 0);
        this.otpForm.setErrors({ credentialsMismatch: true });
        this.otpForm.markAsDirty();
        this.otpForm.markAsTouched();
        window.scroll(0, 0);
      }
    });
  }
  // opens the Privacy Policy / Terms & Conditions modal; accepting there carries
  // the sign up straight on to the OTP step
  /**
   * @param fromSubmit true when Continue was pressed, false when the customer
   * clicked the card to read the documents. Only a submit attempt surfaces the
   * field errors - opening the documents to read them is not one, and flagging
   * empty fields at that point reads as the review itself having failed.
   */
  showLegalModal(fromSubmit = false) {
    if (this.legalAccepted) return;

    // The documents can be read at any point. Accepting is what needs an email
    // and a strong password, since it sends the sign up straight off - so the
    // modal opens either way and only offers Accept when there is a form to
    // submit.
    const canAccept = !this.signUpForm.invalid && this.ispasswordStrong;
    if (!canAccept && fromSubmit) {
      this.signUpForm.markAsDirty();
      this.signUpForm.markAllAsTouched();
    }

    this.bsModalRef = this.modalService.show(LegalConsentComponent, {
      initialState: {
        userEmail: (this.signUpForm.controls['doctor_email'].value || '').trim(),
        canAccept
      },
      class: 'modal-dialog-centered legal-modal-wrapper',
      ignoreBackdropClick: true
    });

    this.bsModalRef.content.onAccept.subscribe(() => {
      this.legalAccepted = true;
      this.submitForm();
    });
  }

  showReferralModal() {
    const initialState = {
    };
    this.bsModalRef = this.modalService.show(ReferralCodeComponent, {
      initialState,
      class: 'modal-dialog-centered bs-modal-wrapper'
    });

    this.bsModalRef.content.onReferralCode.subscribe((referralCode: string) => {
      // console.log('Referral code received:', referralCode);
      this.referral_code = referralCode;
    });
  }
  RemoveReferralCode() {
    this.referral_code = ''
  }
  renewOtp(): void {
    this.otpForm.reset();
    this.errorotp = '';
    this.selectedStep = this.step.REGISTER;
    this.submitForm();
    this.countdown = 180;
    // this.startCountdown();
  }

  startCountdown(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  
    this.countdownInterval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.countdownInterval);
      }
    }, 1000);
  }
  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  }
  bactoRegister() {
    this.selectedStep = this.step.REGISTER;
    // this.signUpForm.doctor_email ='';
    this.checkBtn = false;
    // Coming back reopens the details for editing, so the acceptance no longer
    // matches what is being agreed to - the modal is shown again and accepting
    // overwrites the stored capture with one showing the new details.
    this.resetLegalAcceptance();
  }

  // Sends the customer back through the modal, without touching the stored
  // capture: accepting again overwrites it, and until they do the previous one
  // is still the best record there is.
  resetLegalAcceptance() {
    this.legalAccepted = false;
  }
  checkedTerms() {
    // debugger
    this.checkBtn = !this.checkBtn;
  }
}

